import { useEffect } from 'react';
import type { RefObject } from 'react';
import { useLocation } from 'react-router';

/**
 * Новый экран открывается сверху, а не там, где игрок бросил предыдущий.
 *
 * `ScrollRestoration` из react-router здесь не работает: он двигает окно,
 * а окно в мини-аппе не скроллится вовсе — `#root` закрыт `overflow: hidden`
 * ради масштабируемого холста. Скроллится `.main`, и он ОДИН на все
 * маршруты: защищённый корень смонтирован один раз, меняется только
 * содержимое `<Outlet/>`. Поэтому позиция прокрутки переезжает с экрана
 * на экран, и игрок, пролистав рейтинг, попадает в середину Карьеры.
 *
 * Сброс по `pathname`, а не по всему location: смена `?result=…` — это
 * модалка поверх того же экрана, прокрутку под ней трогать незачем.
 */
export function useScrollToTop(ref: RefObject<HTMLElement | null>): void {
  const { pathname } = useLocation();

  useEffect(() => {
    // Без `behavior: smooth`: переход между вкладками должен НАЧАТЬСЯ
    // сверху, а не доехать туда на глазах у игрока
    ref.current?.scrollTo({ top: 0 });
  }, [pathname, ref]);
}
